"use client"

import { useTranslation } from "react-i18next"
import logo from "../../assets/images/MATCHA.svg" // Import the default logo image
import mobileLogo from "../../assets/images/MOBILE_MATCHA.svg" // Import the mobile logo image
import icon1 from "../../assets/icons/ask.svg" // Import the first icon
import icon2 from "../../assets/icons/pause.svg"
import icon3 from "../../assets/icons/music.svg"
import icon4 from "../../assets/icons/music-mute.svg"
import icon5 from "../../assets/icons/restart.svg"
import icon6 from "../../assets/icons/leaderboard.svg" // Import the leaderboard icon
import LanguageSwitcher from "./LanguageSwitcher"
import "./NavBar.css" // Import the CSS for the NavBar

// Update the component to include a new prop for the leaderboard click handler
const NavBar = ({ onIcon1Click, onIcon2Click, onIcon3Click, onRestartClick, onLeaderboardClick, isMuted }) => {
  const { t } = useTranslation()

  // Check if device is mobile
  const isMobile = window.innerWidth <= 768

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault()
            // Instead of reloading, we'll reset the game state
            localStorage.removeItem("wasPlayingDailyChallenge")
            window.location.reload()
          }}
        >
          <img src={logo || "/placeholder.svg"} alt={t('nav.logoAlt')} className="desktop-logo" />
        </a>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault()
            // Instead of reloading, we'll reset the game state
            localStorage.removeItem("wasPlayingDailyChallenge")
            window.location.reload()
          }}
        >
          <img src={mobileLogo || "/placeholder.svg"} alt={t('nav.logoAltMobile')} className="mobile-logo" />
        </a>
      </div>
      <div className="navbar-icons">
        <img
          src={icon5 || "/placeholder.svg"}
          alt={t('nav.restart')}
          className="navbar-icon"
          onClick={(e) => {
            e.preventDefault()
            onRestartClick()
          }}
          title={t('nav.restart')}
        />
        <img
          src={icon1 || "/placeholder.svg"}
          alt={t('nav.howToPlay')}
          className="navbar-icon"
          onClick={(e) => {
            e.preventDefault()
            onIcon1Click()
          }}
          title={t('nav.howToPlay')}
        />
        <img
          src={icon2 || "/placeholder.svg"}
          alt={t('nav.selectDifficulty')}
          className="navbar-icon"
          onClick={(e) => {
            e.preventDefault()
            onIcon2Click()
          }}
          title={t('nav.selectDifficulty')}
        />
        <img
          src={(isMuted ? icon4 : icon3) || "/placeholder.svg"}
          alt={isMuted ? t('nav.music') : t('nav.music')}
          className="navbar-icon"
          onClick={(e) => {
            e.preventDefault()
            onIcon3Click()
          }}
          title={isMuted ? t('nav.unmuteMusic') : t('nav.muteMusic')}
        />
        {/* Add the leaderboard icon */}
        <img
          src={icon6 || "/placeholder.svg"}
          alt={t('nav.leaderboard')}
          className="navbar-icon"
          onClick={(e) => {
            e.preventDefault()
            onLeaderboardClick() // No need to pass parameter, handled in App.js
          }}
          title={t('nav.leaderboard')}
        />
        {/* Language Switcher (desktop) */}
        <LanguageSwitcher isMobile={false} />
      </div>
    </nav>
  )
}

export default NavBar

